import { render, staticRenderFns } from "./TitleAndDataLink.vue?vue&type=template&id=2da12604&"
import script from "./TitleAndDataLink.vue?vue&type=script&lang=js&"
export * from "./TitleAndDataLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports